import { jsx as t } from "react/jsx-runtime";
import { L as _, M as v, d as n } from "../../vendor-Dd6qj6gJ.js";
import { useMemo as y } from "react";
import { getSpacingClasses as h } from "../../utils/getSpacingClasses/index.js";
import { omitStyleRenderProps as S } from "../../utils/omitStyleRenderProps/index.js";
import { Tag as w } from "../Tag/index.js";
import '../../assets/index56.css';const G = "_tagGroup_1t442_1", $ = "_tagList_1t442_7", x = "_wrap_1t442_13", a = {
  tagGroup: G,
  tagList: $,
  wrap: x
};
function N({
  color: r,
  onAction: c,
  wrap: f = !0,
  icon: l,
  p: d,
  pr: m,
  pb: p,
  pl: u,
  pt: g,
  onRemove: s,
  ...o
}) {
  const b = y(() => new Set(
    Array.from(o.items ?? []).flatMap((e) => e.removable !== !1 ? [e.id] : [])
  ), [o.items]);
  return /* @__PURE__ */ t(
    _,
    {
      ...S(o),
      className: n(a.tagGroup, h({ p: d, pb: p, pl: u, pr: m, pt: g })),
      shouldSelectOnPressUp: !1,
      selectionBehavior: void 0,
      selectedKeys: void 0,
      onSelectionChange: void 0,
      defaultSelectedKeys: void 0,
      disallowEmptySelection: !1,
      escapeKeyBehavior: "none",
      selectionMode: "none",
      onAction: c,
      onRemove: (e) => {
        if (s)
          for (const i of e)
            b.has(i) && s(i);
      },
      "data-component": "TagGroup",
      children: /* @__PURE__ */ t(
        v,
        {
          items: o.items,
          className: n(a.tagList, { [a.wrap]: f }),
          dependencies: [r],
          children: (e) => /* @__PURE__ */ t(w, { ...e, icon: e.icon ?? l, color: e.color ?? r })
        }
      )
    }
  );
}
export {
  N as TagGroup
};
